export const inputCls =
  "w-full bg-navy-900/50 border border-white/10 text-white rounded-sm px-4 py-3 text-sm placeholder:text-slate-500 focus:ring-1 focus:ring-gold-500 focus:border-gold-500 focus:outline-none transition-colors";
export const labelCls = "text-sm font-medium tracking-wide text-slate-300 mb-2 block";

export function Field({ label, children }) {
  return (
    <div>
      <label className={labelCls}>{label}</label>
      {children}
    </div>
  );
}

export function Kicker({ children }) {
  return <span className="text-xs tracking-[0.2em] uppercase font-bold text-gold-500">{children}</span>;
}
